import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CouponCodeService {
  constructor(private afs: AngularFirestore) {}

  public getDiscountValue(couponCode: string): Observable<any> {
    return this.afs.collection('coupons').doc(couponCode).valueChanges();
  }
}
